import * as actionTypes from '../actions/actionTypes';

const initialState = {
  loading: false,
  message: null,
  phoneCallLogsMy: [],
  phoneCallLogsAll: [],
  pageMy: 0,
  pageAll: 0,
  openEnhancedSearch: false,
  noMoreItems: false,
  callDetails: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CALL_LOGS_STORE:
      return {
        ...state,
        loading: action.payload.loading,
      };
    case actionTypes.CALL_LOGS_FAILURE:
      return {
        ...state,
        loading: action.payload.loading,
        message: action.payload.message,
      };
    case actionTypes.CALL_LOGS_OPEN_ENHANCED_SEARCH:
      return {
        ...state,
        openEnhancedSearch: action.payload.open,
      };
    case actionTypes.CALL_NO_MORE_ITEMS:
      return {
        ...state,
        noMoreItems: action.payload.noMoreItems,
      };
    case actionTypes.CALL_LOGS_SUCCESS: {
      const {
        phoneCallLogsMy,
        phoneCallLogsAll,
        pageMy,
        pageAll,
      } = action.payload;

      if (phoneCallLogsMy) {
        return {
          ...state,
          loading: action.payload.loading,
          phoneCallLogsMy,
          pageMy,
        };
      }
      return {
        ...state,
        loading: action.payload.loading,
        phoneCallLogsAll,
        pageAll,
      };
    }
    case actionTypes.CALL_LOGS_UPDATE_RECORDING_STATUS:
      return {
        ...state,
        phoneCallLogsMy: action.payload.phoneCallLogsMy,
        phoneCallLogsAll: action.payload.phoneCallLogsAll,
        callDetails: action.payload.callDetails,
      };
    case actionTypes.CALL_LOGS_RESET: {
      return initialState;
    }
    case actionTypes.RESET_CALL_LOGS_PAGES: {
      return {
        ...state,
        pageMy: initialState.pageMy,
        pageAll: initialState.pageAll,
      };
    }
    case actionTypes.CALL_LOGS_CALL_DETAILS: {
      return {
        ...state,
        callDetails: action.payload.callDetails,
      };
    }
    default:
      return state;
  }
};

export default reducer;
